export default __webpack_public_path__ + "static/media/discover.a47b2c3c.png";